import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, KeyRound, ExternalLink } from "lucide-react";

const TYPE_META = {
    verification: { label: "Verifica Email", icon: Mail },
    password_reset: { label: "Reset Password", icon: KeyRound },
};

export default function AdminOutbox() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/outbox")
            .then(({ data }) => setItems(data.items))
            .catch(() => toast.error("Errore caricamento outbox"))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="admin-outbox-page">
            <h1 className="font-serif text-3xl mb-2">Email in Uscita</h1>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mb-8 max-w-2xl">
                Coda di sviluppo: nessun SMTP è ancora collegato. Ogni email di verifica o reset viene
                salvata qui con il link cliccabile per completare il flusso.
            </p>

            {loading && <div className="text-[hsl(var(--muted-foreground))]">Caricamento…</div>}

            {!loading && items.length === 0 && (
                <div className="text-[hsl(var(--muted-foreground))] italic">Nessuna email in coda.</div>
            )}

            <div className="space-y-3">
                {items.map((it) => {
                    const meta = TYPE_META[it.type] || { label: it.type, icon: Mail };
                    const Icon = meta.icon;
                    return (
                        <div key={it.id} className="bg-white border border-[hsl(var(--border))] rounded-sm p-5" data-testid={`outbox-entry-${it.id}`}>
                            <div className="flex items-start gap-3">
                                <Icon className="w-4 h-4 mt-1 text-[hsl(var(--primary))] shrink-0" strokeWidth={1.5} />
                                <div className="flex-1 min-w-0">
                                    <div className="flex flex-wrap items-baseline gap-2 mb-1">
                                        <span className="co-badge-neutral">{meta.label}</span>
                                        <span className="text-xs text-[hsl(var(--muted-foreground))]">
                                            → {it.to_email}
                                        </span>
                                        <span className="text-xs text-[hsl(var(--muted-foreground))] ml-auto">
                                            {typeof it.sent_at === "string" ? new Date(it.sent_at).toLocaleString("it-IT") : ""}
                                        </span>
                                    </div>
                                    <div className="font-serif text-lg text-[hsl(var(--foreground))] mb-1">
                                        {it.subject}
                                    </div>
                                    <p className="text-sm text-[hsl(var(--muted-foreground))] whitespace-pre-wrap mb-3">
                                        {it.body}
                                    </p>
                                    <Link
                                        to={it.action_link}
                                        className="inline-flex items-center gap-2 text-sm text-[hsl(var(--primary))] hover:underline underline-offset-4"
                                        data-testid={`outbox-action-link-${it.id}`}
                                    >
                                        <ExternalLink className="w-3.5 h-3.5" />
                                        Apri link
                                    </Link>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
